const USER_IDLE_MS = 90_000;

export const isValidBuildSha = (buildSha: string) => Boolean(buildSha) && buildSha !== 'unknown';

export const getBuildRefreshUrl = (href: string, buildSha: string) => {
  if (!isValidBuildSha(buildSha)) return href;

  const url = new URL(href);
  url.searchParams.set('__build', buildSha);
  return url.toString();
};

export const shouldQueueReloadForSha = ({
  nextBuildSha,
  readLocalStorage,
  writeLocalStorage,
  readSessionStorage,
  writeSessionStorage,
  storageKey
}: {
  nextBuildSha: string;
  readLocalStorage: (key: string) => string | null;
  writeLocalStorage: (key: string, value: string) => void;
  readSessionStorage: (key: string) => string | null;
  writeSessionStorage: (key: string, value: string) => void;
  storageKey: string;
}) => {
  if (!isValidBuildSha(nextBuildSha)) return false;

  const lastBuildSha = readLocalStorage(storageKey);
  if (!lastBuildSha || lastBuildSha === nextBuildSha) {
    writeLocalStorage(storageKey, nextBuildSha);
    return false;
  }

  const guardKey = `reloaded-for-build-${nextBuildSha}`;
  if (readSessionStorage(guardKey)) return false;

  writeSessionStorage(guardKey, '1');
  writeLocalStorage(storageKey, nextBuildSha);
  return true;
};

export const shouldApplyQueuedReload = ({
  now,
  lastInteractionAt,
  visibilityState,
  userIdleMs = USER_IDLE_MS
}: {
  now: number;
  lastInteractionAt: number;
  visibilityState: DocumentVisibilityState;
  userIdleMs?: number;
}) => {
  if (visibilityState === 'hidden') return true;
  return now - lastInteractionAt >= userIdleMs;
};

export const BUILD_REFRESH_USER_IDLE_MS = USER_IDLE_MS;
